const BASE_URL = 'http://localhost:8080';

export const githubService = {
  async getAuthUrl() {
    try {
      // Get the JWT token from localStorage
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      console.log('Fetching GitHub auth URL from:', `${BASE_URL}/integrations/github/url`);
      const response = await fetch(`${BASE_URL}/integrations/github/url`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('GitHub auth URL error:', {
          status: response.status,
          statusText: response.statusText,
          errorData
        });
        throw new Error(errorData.detail || 'Failed to get GitHub auth URL');
      }
      
      const data = await response.json();
      console.log('GitHub auth URL response:', data);
      return data.url;
    } catch (error) {
      console.error('Error getting GitHub auth URL:', error);
      throw error;
    }
  },

  async handleCallback(code, state) {
    try {
      // Get the JWT token from localStorage
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      console.log('Handling GitHub callback with:', { code, state });
      const response = await fetch(`${BASE_URL}/integrations/github/callback`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code, state }),
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('GitHub callback error:', {
          status: response.status,
          statusText: response.statusText,
          errorData
        });
        throw new Error(errorData.detail || 'Failed to complete GitHub integration');
      }
      
      const data = await response.json();
      console.log('GitHub callback success:', data);
      return data;
    } catch (error) {
      console.error('Error handling GitHub callback:', error);
      throw error;
    }
  }
}; 